// Spanish content dictionary (fully translated).

const es = {
  meta: {
    home: {
      title: "Encuentra el mejor lugar para perforar un pozo de agua",
      description:
        "Servicios expertos en localización de aguas subterráneas. ¡Ahorra miles de dólares encontrando el lugar perfecto para perforar tu pozo de agua!",
    },
    services: {
      title: "Servicios de Localización de Agua y Estudios Geofísicos",
      description:
        "Descubra los servicios de AquaFinders: encontrar agua, evitar agua y fracturas, resistividad del suelo y estudios geofísicos para proyectos residenciales, agrícolas y comerciales.",
    },
    findWater: {
      title: "Encontrar Agua - El Mejor Lugar para Perforar",
      description:
        "Estudios geofísicos no invasivos que identifican el mejor lugar para perforar un pozo de agua productivo y reducen el riesgo de pozos secos.",
    },
    avoidWater: {
      title: "Evitar Agua y Fracturas Antes de Excavar",
      description:
        "Identifique agua y fracturas subterráneas antes de perforar cimientos profundos o infraestructura con los estudios geofísicos de AquaFinders.",
    },
    resistivity: {
      title: "Resistividad del Suelo para Proyectos de Tierra y Ambientales",
      description:
        "Estudios de resistividad eléctrica del suelo para subestaciones, vertederos y sistemas de conexión a tierra industriales, además de evaluación de contaminación.",
    },
    studies: {
      title: "Estudios Geofísicos, Mineros y Ambientales",
      description:
        "Estudios geológicos, hidrogeológicos y de resistividad para apoyar proyectos ambientales, de construcción y de minería.",
    },
    process: {
      title: "Proceso y Precios para la Localización de Pozos",
      description:
        "Conozca el proceso paso a paso y los precios transparentes de AquaFinders para estudios geológicos y de Imágenes de Resistividad Eléctrica (ERI).",
    },
    about: {
      title: "Sobre AquaFinders - Expertos en Aguas Subterráneas",
      description:
        "Un equipo especializado de geólogos e hidrogeólogos que utiliza tecnología de vanguardia para localizar los mejores lugares para pozos de agua productivos.",
    },
    contact: {
      title: "Contacte a AquaFinders",
      description:
        "Póngase en contacto con AquaFinders para encontrar la ubicación perfecta de su pozo. Hablamos español e inglés.",
    },
    faq: {
      title: "Preguntas Frecuentes",
      description:
        "Respuestas a preguntas comunes sobre los servicios de localización de pozos de agua de AquaFinders: costos, proceso, garantías y profundidad del estudio.",
    },
    gallery: {
      title: "Galería de Imágenes - Resistividad y Trabajo de Campo",
      description:
        "Una galería con resultados de imágenes de resistividad y trabajo de campo de AquaFinders.",
    },
    request: {
      title: "Comenzar ahora - Contacto Inicial",
      description:
        "Por favor, infórmenos sobre su proyecto y nos pondremos en contacto para discutir los próximos pasos.",
    },
    success: {
      title: "Gracias por Contactarnos",
      description: "Su mensaje ha sido enviado con éxito.",
    },
    sitemap: {
      title: "Mapa del Sitio",
      description:
        "Mapa del sitio web de AquaFinders - encuentra todas nuestras páginas en un solo lugar.",
    },
  },

  htmlLang: "es-ES",

  nav: {
    services: "Servicios",
    pricing: "Precios",
    about: "Acerca de",
    start: "Comenzar ahora",
    faq: "Preguntas Frecuentes",
    contact: "Contacto",
    otherLanguage: "Versión en Inglés",
  },

  langSwitch: { enLabel: "English Language", esLabel: "Spanish Language" },

  common: {
    weAreInsured: "¡Estamos asegurados!",
    startNow: "Comenzar ahora",
    freeConsultation: "Consulta Gratuita",
    imageGallery: "Galería de Imágenes",
    sampleResistivity: "Ejemplo de imagen de resistividad",
    infoProcess:
      "Haga clic aquí para obtener más información sobre nuestro proceso...",
    skipToContent: "Saltar al contenido principal",
    home: "Inicio",
  },

  hero: {
    title: "¡Encuentre el mejor lugar para perforar su pozo de agua!",
    description:
      "¡Los pozos secos o de bajo rendimiento son un gran riesgo! Aparte de arruinar su presupuesto, también pueden retrasar su proyecto de construcción. En AquaFinders, combinamos tecnología avanzada de imágenes subterráneas y análisis geológico experto para evaluar las aguas subterráneas ocultas debajo de su terreno. Le ayudaremos a seleccionar con confianza la ubicación óptima para la perforación, mejorando significativamente las posibilidades de un pozo productivo que le beneficiará por mucho tiempo.",
    audioSrc: "/podcast-es.mp4",
    audioLabel: "Podcast de introducción de AquaFinders",
  },

  explanationLead:
    "Proporcionamos a perforadores de pozos y constructores asesoramiento experto para identificar los mejores lugares donde perforar.",
  explanationStrong: "",
  explanationTail: "",

  services: {
    heading: "Nuestros Servicios",
    cards: {
      findWater: {
        title: "Encontrar Agua",
        description:
          "Utilizamos técnicas científicas avanzadas para identificar ubicaciones óptimas para la perforación de pozos - residencial, comercial y agricultural.",
      },
      avoidWater: {
        title: "Evitar Agua",
        description:
          "A veces quieres evitar el agua, como al excavar cimientos profundos, depósitos de gas, vertederos, etc. También podemos ayudarte con eso.",
      },
      resistivity: {
        title: "Resistividad Subterránea",
        description:
          "Prueba requerida para proyectos de conexión a tierra para subestaciones y sistemas de transmisión, granjas solares, plantas industriales, etc.",
      },
      studies: {
        title: "Estudios",
        description:
          "Estudios geofísicos e hidrogeofísicos de su propiedad, para asistir en el manejo de trabajos ambientales, de construcción y minería.",
      },
    },
  },

  whoHires: {
    heading: "¿Quién nos contrata?",
    items: [
      {
        title: "Residencial",
        description:
          "Propietarios que planean perforar pozos de agua en construcciones nuevas o sitios existentes.",
      },
      {
        title: "Agricultural",
        description:
          "Granjas que buscan los mejores lugares para perforar pozos de agua de alto rendimiento para riego de cultivos o consumo animal.",
      },
      {
        title: "Comercial",
        description:
          "Constructores que buscan estudiar un terreno antes de cavar, para evitar aguas y fracturas subterráneas.",
      },
    ],
  },

  about: {
    heading: "Sobre Nosotros",
    paragraphs: [
      "AquaFinders es un servicio especializado en la localización de aguas subterráneas que opera principalmente en Carolina del Norte, Carolina del Sur, Georgia, Tennessee y Kentucky, con disponibilidad de servicio en todo el país bajo solicitud. Con nuestro equipo de cinco geólogos/hidrogeólogos, un ingeniero forestal, un ingeniero agrónomo y técnicos locales, utilizamos tecnología de vanguardia para localizar los mejores lugares para perforar pozos de agua productivos.",
      "Fundados en el principio de que todos merecen acceso a agua limpia y confiable, nuestros expertos han ayudado a cientos de propietarios, agricultores y empresas a evitar el costoso error de perforar en el lugar equivocado.",
      "Nuestro enfoque científico combina análisis geofísico con imágenes hidrogeofísicas—también conocidas como Imágenes de Resistividad Eléctrica (ERI) o Tomografía de Resistividad Eléctrica (ERT)—para maximizar tus posibilidades de encontrar agua y señalar las áreas en tu sitio con la mayor probabilidad de flujo de agua fuerte.",
    ],
    closing: ["Llamanos hoy para recibir más información. ¡Tranquilidad garantizada!"],
    imageAlt: "Equipo de AquaFinders realizando un estudio de aguas subterráneas",
  },

  servicePages: {
    findWater: {
      heading: "Descubra Agua con Confianza",
      body: [
        "En AquaFinders, nos especializamos en estudios geofísicos no invasivos para identificar las mejores ubicaciones para perforar pozos. Utilizando una combinación de técnicas avanzadas —incluyendo el análisis de imágenes satelitales, la evaluación topográfica, la investigación hidrogeológica y estudios de resistividad eléctrica en el sitio— le ofrecemos una comprensión clara y detallada de las condiciones subterráneas de su propiedad. Nuestro enfoque respaldado por la ciencia reduce drásticamente el riesgo de perforar pozos secos, ahorrándole tiempo, dinero y recursos.",
        "Nuestros estudios geofísicos están diseñados para ser rentables y respetuosos con el medio ambiente. Al utilizar técnicas no invasivas, minimizamos el impacto sobre el entorno mientras proporcionamos datos precisos y confiables para la perforación de pozos. Confíe en AquaFinders para localizar agua de manera más eficiente, con mayor precisión y tranquilidad.",
      ],
    },
    avoidWater: {
      heading: "Evitando fracturas y agua",
      body: [
        "En AquaFinders, también podemos ayudarle a evitar perforar en áreas con fracturas o agua. Nuestros estudios geofísicos no invasivos están diseñados para identificar posibles problemas antes de que comience a perforar, garantizando que pueda tomar decisiones informadas. Utilizando una combinación de técnicas avanzadas —incluyendo el análisis de imágenes satelitales, la evaluación topográfica, la investigación hidrogeológica y estudios de resistividad eléctrica en el sitio— le ofrecemos una comprensión clara y detallada de las condiciones subterráneas de su propiedad. Nuestro enfoque respaldado por la ciencia reduce drásticamente el riesgo de perforar pozos secos, ahorrándole tiempo, dinero y recursos.",
        "Los constructores y contratistas pueden beneficiarse de nuestros servicios al evitar errores costosos y asegurar que sus proyectos se completen a tiempo y dentro del presupuesto. Nuestros estudios geofísicos están diseñados para ser rentables y respetuosos con el medio ambiente. Al utilizar técnicas no invasivas, minimizamos el impacto sobre el entorno mientras proporcionamos datos precisos y confiables. Confíe en AquaFinders para excavar con confianza, usar sus recursos de manera más eficiente y lograr tranquilidad.",
      ],
    },
    resistivity: {
      heading: "Resistividad del Suelo",
      body: [
        "Nuestros estudios de Resistividad del Suelo suelen ser necesarios para centrales eléctricas, vertederos y otros proyectos que requieren este tipo de estudios ambientales. También pueden utilizarse para evaluar posibles derrames y contaminación en el suelo.",
        "Utilizamos la tecnología más reciente para brindarle los mejores resultados. Nuestro equipo de expertos realizará un análisis exhaustivo de su sitio, utilizando técnicas avanzadas para medir la resistividad del suelo. Esta información es crucial para comprender las condiciones subterráneas de su sitio, incluyendo posibles infiltraciones químicas que ya ocurrieron o la posibilidad de contaminación futura de los mantos acuíferos.",
      ],
    },
    studies: {
      heading: "Estudios Mineros y Ambientales",
      body: [
        "Muchos proyectos requieren una comprensión profunda de las condiciones subterráneas. Nuestro equipo puede realizar una variedad de estudios, incluyendo geológicos, hidrogeológicos y de resistividad, que a menudo son necesarios para proyectos mineros y ambientales.",
        "Contáctenos para obtener más información sobre nuestros servicios y cómo podemos ayudarle con su proyecto.",
      ],
    },
  },

  servicesList: {
    heading: "Servicios",
    sampleHeading: "Ejemplo de imagen de resistividad",
    sampleDescription:
      "La imagen de resistividad muestra una vista en sección transversal del subsuelo a lo largo de una línea recta. Las zonas de baja resistividad (colores cálidos como el rojo y el amarillo) pueden indicar suelo húmedo o acuíferos, mientras que las zonas de alta resistividad (colores fríos como el azul y el verde) suelen representar roca, suelo seco o capas impermeables.",
    cards: [
      {
        key: "findWater",
        title: "Encontrar Agua",
        subtitle: "Encuentre la mejor ubicación para su pozo de agua",
        items: [
          "Propietarios que buscan el mejor lugar para perforar un pozo y maximizar su inversión",
          "Personas que desean optimizar el potencial de agua de su terreno para cultivos, jardinería y ganado",
          "Compradores de terrenos que quieren tener la certeza de que la tierra que adquieren puede producir el agua que necesitan",
          "Empresas de perforación de pozos que buscan aumentar su tasa de éxito y la satisfacción del cliente",
          "Constructores que buscan minimizar los retrasos en la construcción y reducir gastos imprevistos",
          "Agricultores que necesitan una fuente de agua confiable para el riego y el ganado",
          "Desarrolladores que planifican subdivisiones o proyectos comerciales que requieren múltiples pozos",
          "Terratenientes que se preparan para futuras construcciones, agricultura o para aumentar el valor de reventa",
        ],
      },
      {
        key: "avoidWater",
        title: "Evitar Agua",
        subtitle:
          "Evite fracturas subterráneas y agua inesperada durante la construcción",
        items: [
          "Constructores que necesitan evitar sorpresas costosas como fracturas subterráneas, cavidades o agua inesperada durante los trabajos de cimentación",
          "Ingenieros que planifican zapatas profundas, muros de contención o sótanos, asegurando la estabilidad del suelo y la roca",
          "Contratistas que instalan postes grandes, torres o cercas que requieren condiciones de perforación seguras y secas",
          "Desarrolladores de terrenos que buscan prevenir retrasos y minimizar los riesgos de construcción",
          "Propietarios que planifican piscinas o grandes proyectos de paisajismo donde las condiciones subterráneas son importantes",
          "Empresas de servicios públicos y municipios que instalan tuberías, cables o infraestructura subterránea",
        ],
      },
      {
        key: "resistivity",
        title: "Resistividad del Suelo",
        subtitle:
          "Estudios de resistividad del suelo para proyectos más seguros e inteligentes",
        items: [
          "Ingenieros y contratistas que necesitan datos de resistividad del suelo para centrales eléctricas, subestaciones y diseños de sistemas de conexión a tierra",
          "Consultores ambientales que evalúan vertederos, sitios de eliminación de residuos o áreas de almacenamiento de materiales peligrosos",
          "Gerentes de proyecto que supervisan desarrollos industriales donde los riesgos de derrames o la contaminación del suelo son preocupaciones",
          "Terratenientes que investigan posible contaminación del suelo antes de comprar o desarrollar una propiedad",
          "Empresas que evalúan riesgos de infiltración química que podrían amenazar los mantos acuíferos y las fuentes de agua subterránea",
          "Municipios que realizan estudios de impacto ambiental para la expansión de infraestructura",
        ],
      },
      {
        key: "studies",
        title: "Minería y Medio Ambiente",
        subtitle:
          "Estudios mineros y ambientales para un desarrollo más seguro e inteligente",
        items: [
          "Empresas mineras que necesitan estudios geológicos e hidrogeológicos detallados antes de la exploración o excavación",
          "Consultores ambientales que realizan evaluaciones de sitios, estudios de impacto o proyectos de restauración de terrenos",
          "Desarrolladores que buscan comprender los riesgos del subsuelo antes de invertir en proyectos a gran escala",
          "Terratenientes que evalúan la seguridad ambiental y el potencial de recursos de su propiedad",
          "Agencias gubernamentales que requieren evaluaciones de sitios para cumplimiento, remediación o esfuerzos de conservación",
          "Ingenieros que planifican túneles, canteras o movimientos de tierra donde la estabilidad del subsuelo es crítica",
        ],
      },
    ],
  },

  process: {
    title: "Proceso y Precios",
    subtitle: "Para encontrar el mejor lugar para perforar un pozo de agua",
    intro: "Nuestros servicios se dividen en dos partes:",
    prices: [
      {
        amount: "$150",
        muted: true,
        title: "(Opcional) Estudio Hidrogeológico",
        description:
          "Este estudio hidrogeológico preliminar opcional analiza imágenes satelitales para evaluar el potencial de agua de su propiedad. Su objetivo es ayudarle a comprender mejor su terreno y determinar si se recomiendan estudios adicionales o si ya existe un camino claro para la ubicación de su pozo de agua. En otras palabras, es ideal para aquellos que no están seguros de si necesitan los estudios más avanzados descritos a continuación. Si decide continuar con nuestro Estudio Geológico completo, el costo de este estudio preliminar se deducirá del total.",
      },
      {
        amount: "$500",
        title: "(A) Estudio Geofísico",
        description:
          "Este paso implica una evaluación integral de su propiedad a través del análisis detallado de múltiples imágenes satelitales, evaluaciones topográficas, estudios geológicos e investigaciones hidrogeológicas. Este enfoque multicapa nos permite identificar las áreas con el mayor potencial de agua. Con base en estos hallazgos, identificamos las ubicaciones exactas para las pruebas de campo (líneas geofísicas), minimizando las posibilidades de pruebas secundarias innecesarias y maximizando la eficiencia de la encuesta geofísica que realizaremos.",
      },
      {
        amount: "$700",
        title: "(B) Imágenes de Resistividad Eléctrica",
        description:
          "Estudio geofísico de campo utilizando tecnología de Imágenes de Resistividad Eléctrica (ERI), seguido de un análisis completo de datos, interpretación profesional de resultados (múltiples geólogos), generación de informes detallados y una explicación clara de los hallazgos para garantizar una comprensión total y aplicación práctica. Este informe será utilizado por su perforador de pozos/constructor en su toma de decisiones.",
      },
      {
        amount: "$725",
        amountExtra: "extra",
        muted: true,
        title: "(B.1) Posibilidad (en algunos casos)",
        description:
          "Las propiedades sobre una formación geológica sedimentaria pueden requerir el estudio Schlumberger SEV, que es más laborioso y, por lo tanto, requiere una tarifa adicional de $725. Contáctenos para obtener más información o para averiguar si esta tarifa sería aplicable a su propiedad.",
      },
    ],
    note1: "Nota 1: Estos valores no incluyen los impuestos locales.",
    note2:
      "Nota 2: El Estudio Geológico siempre debe completarse antes de un estudio ERI.",
    stepsHeading: "Así es como normalmente funciona:",
    steps: [
      {
        actor: "[Cliente]",
        text: "Usted completa nuestro Formulario de Nuevo Cliente",
        link: true,
      },
      {
        actor: "[AquaFinders]",
        text: "Nos ponemos en contacto con usted para conocer mejor sus necesidades",
      },
      {
        actor: "[Cliente]",
        text: "Usted firma el contrato y realiza el pago ($500)",
      },
      {
        actor: "[AquaFinders]",
        text: "Comenzamos con la caracterización del acuífero y una auditoría regional de pozos, seguido de análisis geoespaciales, topográficos, geológicos e hidrogeofísicos de su propiedad",
      },
      {
        actor: "[AquaFinders]",
        text: "Presentamos su informe y le damos una recomendación clara sobre si debe proceder o no con el siguiente paso: el estudio Geofísico (ERI).",
      },
      {
        actor: "[Juntos]",
        text: "Según los datos recopilados, le ayudaremos a decidir si el Estudio Geofísico es la opción adecuada para usted.",
      },
      {
        actor: "[Cliente]",
        text: "Usted realiza el pago para este segundo estudio ($700)",
      },
      {
        actor: "[AquaFinders]",
        text: "Realizamos el estudio geofísico en su propiedad",
      },
      {
        actor: "[AquaFinders]",
        text: "Le entregamos los resultados finales por correo electrónico, para que pueda enviárselos a su empresa perforadora de pozos o constructor.",
        final: true,
      },
    ],
    notesTitle: "Notas importantes:",
    notes: [
      "Si todo va bien, el proceso puede tomar tan solo tres semanas.",
      "El tiempo de entrega habitual es de aproximadamente cinco semanas.",
      "Ofrecemos servicios urgentes para proyectos de emergencia (pueden aplicarse tarifas adicionales).",
      "Tenga en cuenta que el proceso y los pasos pueden variar según sus necesidades, preferencias, condiciones climáticas y condiciones de su terreno.",
      "Ofrecemos descuentos para proyectos más grandes que requieran múltiples estudios.",
      "Los impuestos de venta no están incluidos en los precios mostrados en este sitio web.",
    ],
    otherPricing:
      "Para conocer los precios de nuestros otros servicios, contáctenos.",
  },

  contact: {
    formHeading: "Formulario de Contacto",
    name: "Su Nombre",
    email: "Dirección de Correo Electrónica",
    phone: "Número de Teléfono",
    preferred: "Forma preferida de comunicación:",
    prefEmail: "Correo Electrónico",
    prefCall: "Llamada Telefónica",
    prefText: "Mensaje de Texto",
    message: "Cuéntenos sobre su proyecto o haganos sus preguntas...",
    captcha: "Captcha",
    submit: "Enviar",
    captchaAlert:
      "¡Por favor complete el campo captcha para comprovar que es humano!",
    readyTitle:
      "¿Está listo para encontrar la ubicación perfecta para perforar su pozo?",
    weSpeak: "Hablamos Español / We speak English",
    byAppointment: "Dirección física solo con cita previa.",
    phoneLabel: "Teléfono",
    phoneHours: "(9-5 PM EST)",
    emailLabel: "Correo Electrónico",
  },

  footer: {
    expertServices: "Servicios Expertos de Localización de Pozos de Agua para",
    serviceArea: "Carolina del Norte y Carolina del Sur, E.E.U.U.",
    nationwide: "con la posibilidad de servicio disponible en todo el país.",
    contactForm: "Formulario de Contacto",
    contactUs: "Contáctanos",
    whatsapp: "Contáctanos por WhatsApp",
    email: "Correo Electrónico",
    trademark: "AquaFinders ™ (Marca Registrada en Trámite)",
    allRights: "Todos los derechos reservados.",
    resultsVary: "Los resultados pueden variar según las condiciones geológicas.",
    siteMap: "Mapa del Sitio",
  },

  faq: {
    title: "Preguntas Frecuentes",
    sections: [
      {
        title: "Encuentre el mejor lugar para perforar un pozo de agua",
        intro: null,
        items: [
          {
            q: "1. ¿Cuál es el costo?",
            a: [
              { type: "process-link" },
              "Nuestros servicios se dividen en dos partes: un Estudio Geológico y un estudio Geofísico (Imágenes de Resistividad Eléctrica - ERI). La primera parte cuesta $500 y es un requisito previo para el segundo estudio, que cuesta $700. Sin embargo, algunas propiedades en los EE. UU. se encuentran sobre formaciones geológicas sedimentarias, lo que requiere el estudio Schlumberger SEV, que es más laborioso y, por lo tanto, requiere la adición de $725 en tarifas adicionales. Contáctenos para saber si su propiedad está o no sobre una formación geológica sedimentaria.",
              "También ofrecemos descuentos para proyectos más grandes que requieran múltiples estudios.",
            ],
          },
          {
            q: "2. ¿Qué incluye?",
            a: [
              { type: "usgs" },
              "En la práctica, producimos dos informes clave. El primero es un Análisis Geofísico de su propiedad, que nos ayuda a identificar las áreas con el mayor potencial de agua subterránea. Con base en esos hallazgos, realizamos una prueba de Tomografía de Resistividad Eléctrica (ERT) específica en la ubicación más prometedora. Los datos recopilados se procesan y analizan cuidadosamente de forma científica, dando como resultado el segundo y último informe, que incluye imágenes detalladas y una evaluación clara del potencial de agua de su propiedad.",
              "Ejemplo de imagen:",
              { type: "ert-image" },
            ],
          },
          {
            q: "3. ¿Cuál es el proceso?",
            a: [
              "El mejor momento para contratar nuestros servicios es antes de contactar a un perforador de pozos, o incluso antes de comprar una propiedad.",
              "Sin embargo, si ya compró el terreno o un perforador de pozos ha presentado una solicitud de permiso, aún podemos realizar nuestro estudio. En algunos casos, esto puede requerir pasos adicionales para modificar el permiso antes de que comience la perforación.",
              "Una vez que nuestro contrato está activo, comenzamos estudiando su propiedad de forma remota, lo que da como resultado un informe inicial. Luego revisaremos esos hallazgos con usted para determinar la ubicación ideal para la segunda fase del estudio, que se realiza en el sitio. Durante esta visita, nuestro equipo realiza pruebas en persona y recopila una amplia gama de datos geológicos y ambientales.",
              "Nuestros geólogos expertos analizan minuciosamente todos los datos y preparan un informe final detallado. Este informe identifica la ubicación exacta con el mayor potencial para un pozo exitoso, lo que le permite dirigir con confianza a su empresa de perforación preferida para que perfore en el lugar óptimo.",
            ],
          },
          {
            q: "4. ¿Es posible obtener resultados negativos?",
            a: [
              "Sí. Aunque utilizamos la mejor ciencia y experiencia disponibles, no podemos garantizar que su propiedad contenga agua o que el flujo de agua satisfaga sus necesidades específicas. Nuestro objetivo es identificar la ubicación con el mayor potencial para un pozo exitoso según las condiciones geológicas existentes de su terreno.",
            ],
          },
          {
            q: "5. ¿Obtendría un reembolso si el resultado es negativo?",
            a: [
              "Lamentablemente, no. El mismo proceso que utilizamos para localizar el mejor lugar para perforar también se usa para determinar si su propiedad tiene bajo o incluso ningún potencial de agua. Esto puede ahorrarle miles de dólares en futuros pozos infructuosos.",
            ],
          },
          {
            q: "6. ¿Hay alguna garantía?",
            a: [
              "Garantizamos que realizaremos un estudio geofísico e hidrogeofísico profesional de su propiedad utilizando métodos y equipos estándar de la industria. Sin embargo, los resultados que obtengamos dependerán completamente de las condiciones geológicas naturales de su propiedad. Estas condiciones pueden afectar el rendimiento de la prueba, incluyendo la profundidad que el equipo puede alcanzar, la precisión de las lecturas y el margen de error general. Nuestro compromiso es entregar datos precisos y basados en la ciencia para ayudarle a tomar la decisión más informada posible.",
            ],
          },
          {
            q: "7. ¿Hasta qué profundidad llegará el estudio?",
            a: [
              "Garantizamos un estudio geofísico e hidrogeofísico profesional de su propiedad utilizando herramientas y métodos estándar de la industria. Sin embargo, la profundidad y la precisión de nuestro análisis dependen de las condiciones geológicas naturales de su sitio. En condiciones favorables —que también pueden verse influenciadas por el clima reciente— nuestro equipo puede permitirnos estudiar profundidades de hasta 600 pies. Independientemente de las condiciones, nuestro objetivo es proporcionarle el informe más preciso y basado en la ciencia para guiar sus decisiones de perforación de pozos.",
            ],
          },
          {
            q: "8. ¿Qué tan grande es el área que cubre el estudio?",
            a: [
              "El estudio geofísico estándar está diseñado para propiedades de hasta 50 acres de tamaño (se aplican tarifas adicionales para propiedades más grandes). Sin embargo, es importante tener en cuenta que la prueba de Tomografía de Resistividad Eléctrica (ERT) no se basa en la cobertura de área. En cambio, produce una imagen vertical en sección transversal del subsuelo a lo largo de una sola línea recta. Nuestra configuración estándar de ERT abarca típicamente aproximadamente 1,181 pies lineales, con la profundidad de penetración determinada por las condiciones geológicas locales.",
            ],
          },
        ],
      },
      {
        title: "Evitando agua subterránea",
        intro: null,
        items: [
          {
            q: "1. ¿Cuál es el costo?",
            a: [
              "El costo estándar de la prueba de Tomografía de Resistividad Eléctrica (ERT) es de $1200 (mil doscientos dólares). Pueden aplicarse tarifas adicionales para propiedades ubicadas fuera de nuestro rango de servicio estándar.",
            ],
          },
        ],
      },
      {
        title: "Pruebas de Resistividad",
        intro:
          "Las pruebas de resistividad son un pilar de la metodología de AquaFinders. Al medir la resistencia eléctrica del terreno, podemos mapear las capas geológicas del subsuelo e identificar formaciones portadoras de agua. Esta técnica no invasiva nos permite determinar la profundidad, el espesor y la calidad del agua de posibles acuíferos, proporcionando datos valiosos para centrales eléctricas, proyectos de vertederos, etc.",
        items: [
          {
            q: "1. ¿Cuál es el costo?",
            a: [
              "El costo estándar de la prueba de Tomografía de Resistividad Eléctrica (ERT) es de $1200 (mil doscientos dólares). Pueden aplicarse tarifas adicionales para propiedades ubicadas fuera de nuestro rango.",
            ],
          },
        ],
      },
      {
        title: "Estudios",
        intro:
          "AquaFinders realiza estudios geofísicos e hidrogeológicos integrales para proyectos ambientales.",
        items: [
          {
            q: "1. ¿Cuál es el costo?",
            a: [
              "El costo estándar de la prueba de Tomografía de Resistividad Eléctrica (ERT) es de $1200 (mil doscientos dólares). Pueden aplicarse tarifas adicionales para propiedades ubicadas fuera de nuestro rango de servicio estándar.",
            ],
          },
        ],
      },
    ],
    costLinkPrefix: "Para más detalles, consulte la página de ",
    costLinkText: "Precios y Proceso",
    costLinkSuffix: ".",
    usgsPrefix:
      "Nuestro trabajo combina el análisis de datos geológicos existentes, imágenes geoespaciales, registros históricos de pozos, mapas topográficos del ",
    usgsText: "USGS",
    usgsSuffix:
      " y patrones climáticos locales para desarrollar una comprensión integral del potencial de agua de su propiedad.",
    ertAlt:
      "Ejemplo de un informe de Tomografía de Resistividad Eléctrica (ERT)",
    importantTitle: "Importante:",
    importantText:
      "No perforamos pozos de agua. En su lugar, estudiamos las condiciones subterráneas de su propiedad para que los perforadores de pozos y las empresas de construcción puedan tomar decisiones informadas.",
  },

  gallery: {
    title: "Galería",
    imageAlts: [
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (1)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (2)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (3)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (4)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (5)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (6)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (7)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (8)",
      "Estudio de campo de AquaFinders — trabajo de resistividad geofísica (9)",
      "Sección transversal de imagen de resistividad de muestra",
    ],
  },

  request: {
    title: "Contacto Inicial",
    intro:
      "Por favor, infórmenos sobre su proyecto y nos pondremos en contacto para discutir los próximos pasos.",
    iframeTitle: "AquaFinders - Contacto Inicial",
    loading: "Cargando…",
  },

  success: {
    title: "¡Gracias por Contactarnos!",
    message:
      "Su mensaje ha sido enviado con éxito. Nuestro equipo se pondrá en contacto con usted lo antes posible.",
    backHome: "Volver al Inicio",
  },

  sitemap: {
    title: "Mapa del Sitio",
    links: {
      home: "Inicio",
      ourServices: "Nuestros Servicios",
      aboutUs: "Sobre Nosotros",
      contactUs: "Contáctanos",
      startNow: "Comenzar ahora",
      pricing: "Proceso y Precios",
      faq: "Preguntas Frecuentes",
      otherLanguage: "Versión en Inglés",
      formSubmission: "Envío de Formulario",
      siteMap: "Mapa del Sitio",
    },
  },

  notFound: {
    title: "Página no encontrada",
    text: "Lo sentimos, la página que busca no existe.",
    backHome: "Volver al Inicio",
  },
};

export default es;
